<template>
  <div id="CaseManage">
    <div v-if="CaseManageShow" class="well" style="padding: 0 1em">
      <div style="text-align: left; padding: 0.5rem 2rem">
        <b-input-group class="mb-3">
          學年度:&nbsp;
          <b-form-input v-model="schyy" placeholder="學年度"></b-form-input>
          學期:&nbsp;
          <b-form-input v-model="smt" placeholder="學期"></b-form-input>

          審核狀態過濾：&nbsp;
          <b-form-select
            class="form-control"
            id="IsCompleteSelectText"
            v-model="selected2"
            ref="selected2"
            :options="options2"
          >
          </b-form-select>
        </b-input-group>
        <b-input-group class="mb-3">
          學號:&nbsp;
          <b-form-input v-model="sid" placeholder="學號"></b-form-input>

          查詢之前申請日期：
          <b-form-input
            v-model="ApplyTime"
            ref="ApplyTime"
            type="text"
            placeholder="YYYY-MM-DD"
            autocomplete="off"
          ></b-form-input>
          <b-input-group-append>
            <b-form-datepicker
              v-model="ApplyTime"
              button-only
              right
              locale="zh-tw"
              aria-controls="example-input"
              @context="onContext"
            ></b-form-datepicker>
          </b-input-group-append>
        </b-input-group>
        <div style="text-align: center; padding: 0.5rem 2rem">
          <button
            href="#"
            @click="getAllApply(0)"
            class="btn btn-outline-success"
            type="button"
            style="font-size: 14px; text-align: right"
          >
            送出查詢
          </button>
        </div>

        產學攜手專班經濟不利助學金系統目前案件申請共 {{ total }}筆
      </div>

      <b-tabs content-class="mt-3" justified>
        <div
          class="dataTables_scrollBody"
          style="
            font-size: 14px;
            position: relative;

            max-height: 100%;

            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >

          <b-table-simple
            class="ncut-table-menu-striped ncut-table-menu"
            fixed
            responsive
            bgcolor="#FFFFFF"
          >
            <b-thead class="ncut-thead-menu">
              <b-tr>
                <b-th style="width: 3em; min-width: 1em">申請案件編號</b-th>
                <b-th style="width: 6em; min-width: 1em">學號</b-th>
                <b-th style="width: 2em; min-width: 1em">學年</b-th>
                <b-th style="width: 1em; min-width: 1em">學期</b-th>
                <b-th style="width: 3em; min-width: 1em">申請日期</b-th>
                <b-th style="width: 3em;min-width: 1em">核准日期</b-th>
                <b-th style="width: 1em; min-width: 1em">目前狀態</b-th>

                <b-th style="width: 6em; min-width: 1em">關係人姓名1</b-th>
                <b-th style="width: 6em; min-width: 1em">身分證字號1</b-th>
                <b-th style="width: 1em; min-width: 1em">與學生關係1</b-th>
                <b-th style="width: 6em; min-width: 1em">關係人姓名2</b-th>
                <b-th style="width: 6em; min-width: 1em">身分證字號2</b-th>
                <b-th style="width: 1em; min-width: 1em">與學生關係2</b-th>
                <b-th style="width: 6em; min-width: 1em">關係人姓名3</b-th>
                <b-th style="width: 6em; min-width: 1em">身分證字號3</b-th>
                <b-th style="width: 1em; min-width: 1em">與學生關係3</b-th>

                <b-th style="width: 100px; min-width: 10em">申請證明文件</b-th>
                <b-th style="width: 90px; min-width: 5em" colspan="2"
                  >管理</b-th
                >
              </b-tr>
            </b-thead>
            <b-tbody class="ncut-tbody-menu">
              <b-tr
                v-for="(i, index) in filteredDocs"
                :key="i.id"
                :index="i.id"
                :name="i.typeName"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <b-td style="text-align: left">
                  {{ i.id }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.sid }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.schyy }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.smt }}
                </b-td>
                <b-td style="text-align: left">
                  {{ getToday(i.applyTime) }}
                </b-td>
                <b-td style="text-align: left">
                  {{ getToday(i.updateTime) }}
                </b-td>
                <b-td style="text-align: left">
                  {{ getIsComplete(i.isComplete, i.reason) }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.relatedName1 }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.relatedId1 }}
                </b-td>
                <b-td style="text-align: left">
                  {{ getRelatedStudent(i.relatedStudent1) }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.relatedName2 }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.relatedId2 }}
                </b-td>
                <b-td style="text-align: left">
                  {{ getRelatedStudent(i.relatedStudent2) }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.relatedName3 }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.relatedId3  }}
                </b-td>
                <b-td style="text-align: left">
                  {{ getRelatedStudent(i.relatedStudent3) }}
                </b-td>

                <b-td style="text-align: left">
                  <span class="sel-file" v-if="i.rowId2 != null">
                    <a
                      :href="'./WebApi/Common/GetDocumentFile/' + i.rowId2"
                      target="_blank"
                    >
                      <img src="@/assets/images/disk.png" />戶籍謄本
                    </a> </span
                  ><br />
                </b-td>
                <b-td style="text-align: left">
                  <button
                              href="#"
                              @click.prevent="EditCase2(i.id)"
                              class="btn btn-outline-danger"
                              type="button"
                              style="font-size: 14px"
                            >
                              修改
                            </button>
                  <button
                    href="#"
                    @click="EditReview(i.id, i.sid,i.isComplete)"
                    class="btn btn-outline-success"
                    type="button"
                    style="font-size: 14px"
                  >
                    審核
                  </button>
                </b-td>
                <b-td style="text-align: left">
                  <button
                    href="#"
                    @click="ListDetailPIData(i.sid)"
                    class="btn btn-outline-success"
                    type="button"
                    style="font-size: 14px"
                  >
                    助學金匯款資料
                  </button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            v-if="total > pageSize"
          />
        </div>
      </b-tabs>
    </div>

    <b-modal size="xl" ref="EditReview" hide-footer>
      <template #modal-title> 審核結果 </template>
      <EditReview
        :id="id"
        :sid="sid"
        :isComplete="isComplete"
        @hideModal="hideModal('EditReview')"
      ></EditReview>
    </b-modal>
    <b-modal size="xl" ref="PersonalInformation3" hide-footer>
      <template #modal-title> 申請者個人資料和匯款資訊檢視 </template>
      <PersonalInformation3
        :sid="editId"
        @hideModal="hideModal('PersonalInformation3')"
      ></PersonalInformation3>
    </b-modal>
    <b-modal size="xl" ref="EditCase2" hide-footer>
      <template #modal-title> 編輯申請 </template>
      <EditCase2
        :id="eid"
        @hideModal="hideModal('EditCase2')"
      ></EditCase2>
    </b-modal>

  </div>
</template>

<script>
import EditReview from '@/components/EditReview.vue'
import PersonalInformation3 from '@/components/PersonalInformationView3.vue'
import EditCase2 from '@/components/EditCase2.vue'
import * as tools from '../tool'
export default {
  name: 'CaseManage',
  data () {
    return {
      isComplete: 0,
      id: 0,
      eid: 0,
      sid: null,
      ApplyTime: null,
      courseName: null,
      CaseManageShow: false,
      EditCaseShow: false,
      cid: null,
      signUpID: null,
      today: null,
      signUpStatus: null,

      selected2: null,

      options2: [
        { value: null, text: '請選擇' },
        { value: '0', text: '待審核' },
        { value: '1', text: '已核准' },
        { value: '2', text: '通過財政調查' },
        { value: '3', text: '退回' },
        { value: '4', text: '退學' },
        { value: '5', text: '準備撥款' },
        { value: '6', text: '未通過財政調查' },
        { value: '9', text: '全部' }
      ],
      schyy: null,
      smt: null,
      ItemID: 99,
      IsComplete: 0,
      editId: 0,
      over: 0,
      total: 0,
      isIE: false,
      inputData: null,
      inputData2: null,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      queryInfo: {
        schyy: null,
        smt: 0,
        Sid: null,
        ApplyTime2: null,
        Item: 99,
        IsComplete: 99
      }
    }
  },
  components: {
    EditReview,
    PersonalInformation3,
    EditCase2
  },
  methods: {
    CaseSelect (id) {
      if (id == 1) {
        this.closeShow()
        this.CaseManageShow = true
        this.getApplyIsComplete()
      }
    },
    EditCase2 (eid) {
      var vm = this
      vm.closeShow()
      vm.EditCaseShow = true
      vm.eid = eid
      vm.$refs.EditCase2.show()
    },

    closeShow () {
      this.CaseManageShow = false
      this.EditCaseShow = false
    },
    hideModal (name) {
      this.$refs[name].hide()
      this.getAllApply(1)
    },
    getAllApply (mode) {
      if (this.selected2 != null) this.IsComplete = this.selected2
      this.queryInfo.schyy = this.schyy
      this.queryInfo.smt = this.smt == null ? 0 : this.smt

      if (mode == 0) { this.queryInfo.Sid = this.sid } else { this.queryInfo.Sid = null }

      this.queryInfo.ApplyTime2 = this.ApplyTime
      this.queryInfo.Item = this.ItemID
      this.queryInfo.IsComplete = this.IsComplete
      this.sid = null
      console.log(this.queryInfo)
      const vm = this
      this.$http
        .put('./WebApi/EconomicDisadvantage/GetAllApply/', vm.queryInfo)
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data
            vm.total = vm.inputData.length
            vm.currentPage = 1
            vm.CaseManageShow = true
          }
        })
        .catch(function (error) {
          alert('網路連線失敗' + error)
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        })
    },
    onContext (ctx) {
      this.ApplyTime = ctx.selectedYMD // Selected: '2022-02-22'
    },

    getToday (updateTime) {
      var dd = new Date(updateTime)
      var today = dd.getDate().toString().padStart(2, '0') // 內建getDate 取到目前年月日
      var mm = (dd.getMonth() + 1).toString().padStart(2, '0') // January is 0!
      var yyyy = dd.getFullYear()
      return tools.stringFormat('{0}-{1}-{2}', yyyy, mm, today)
    },
    getIsComplete (id, reason) {
      var ret
      if (id == 0) ret = '待審核'
      else if (id == 1) ret = '已核准'
      else if (id == 2) {
        ret = '通過財政調查'
      } else if (id == 3) {
        ret = '退回(' + reason + ')'
      } else if (id == 4) {
        ret = '退學'
      } else if (id == 5) {
        ret = '準備撥款'
      } else if (id == 6) {
        ret = '未通過財政調查'
      }
      return ret
    },
    getRelatedStudent (id) {
      var ret
      if (id == 1) ret = '父親'
      else if (id == 2) ret = '母親'
      else if (id == 3) {
        ret = '配偶'
      } else if (id == 5) {
        ret = '法定代理人'
      }

      return ret
    },
    getApplyIsComplete () {
      const vm = this
      vm.selected2 = vm.IsComplete

      this.$http
        .get(
          './WebApi/EconomicDisadvantage/GetApplyIsComplete/'.concat(
            vm.IsComplete
          )
        )
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data
            vm.total = vm.inputData.length
            vm.currentPage = 1
          }
        })
        .catch(function (error) {
          alert('網路連線失敗' + error)
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        })
    },

    EditReview (id, sid, isComplete) {
      var vm = this
      vm.id = id
      vm.sid = sid
      vm.isComplete = isComplete
      vm.$refs.EditReview.show()
    },

    ListDetailPIData (id) {
      var vm = this
      vm.editId = id
      vm.$refs.PersonalInformation3.show()
    }
  },
  computed: {
    filteredDocs: function () {
      let data = []
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        )
      }
      return data
    },

    headerColor () {
      return '#f7e8aa'
    }
  },
  created () {
    console.log('======created CaseManageView =====')
    this.isIE =
      navigator.userAgent.indexOf('MSIE ') > -1 ||
      navigator.userAgent.indexOf('Trident/') > -1 ||
      navigator.userAgent.indexOf('Edge') > -1
    const vm = this

    vm.CaseManageShow = true

    vm.getApplyIsComplete()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
